import React from 'react'

const LayersContext = React.createContext({})

export default LayersContext
